import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";
import Navbar from "../header";
import Footer from "../footer";

const NotFound = () => {
  return (
    <>

     <Navbar menuColor="red" />

    <div className="notfound-container">
      <div className="notfound-overlay"></div>

      <div className="notfound-content">
        <div className="error-code">404</div>

        <h1>Oops! Page Not Found</h1>

        <p>
          The page you are looking for might have been removed, renamed,
          or is temporarily unavailable.
        </p>

        <div className="notfound-buttons">
          <Link to="/" className="home-btn">
            Go Back Home
          </Link>

          <button
            className="back-btn"
            onClick={() => window.history.back()}
          >
            Previous Page
          </button>
        </div>
      </div>

      <div className="floating-circle circle-1"></div>
      <div className="floating-circle circle-2"></div>
      <div className="floating-circle circle-3"></div>
      <div className="floating-circle circle-4"></div>
    </div>

       <Footer />
    </>
  );
};

export default NotFound;